import React, { useState, useEffect } from "react";
import { ChevronDown } from "lucide-react";
import { SettlementPage } from "./SettlementPage";
import { useLocation } from "react-router-dom";
import styled, { createGlobalStyle } from "styled-components";

// Global style for kt_app_content_container
const GlobalStyle = createGlobalStyle`
  #kt_app_content_container {
    margin-top: -50px !important;
  }
`;

// Styled Components
const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 24px;
  background-color: #f5f8fa;
  min-height: 100vh;
`;

const HeaderContainer = styled.div`
  position: relative;
  z-index: 1000;
  margin-bottom: 24px;
`;

const HeaderTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;

  h1 {
    font-size: 24px;
    font-weight: 600;
    color: #181c32;
    margin: 0;
  }
`;

const DropdownMenu = styled.div<{ $isOpen: boolean }>`
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 4px;
  width: 184px;
  background: white;
  border: 1px solid #e4e6ef;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  display: ${(props) => (props.$isOpen ? "block" : "none")};
  z-index: 1000;
`;

const DropdownItem = styled.div<{ $isActive: boolean }>`
  display: grid;
  grid-template-columns: 24px 1fr;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  cursor: pointer;
  background: ${(props) => (props.$isActive ? "#EBF7F9" : "white")};
  transition: all 0.2s ease;

  &:hover {
    background: ${(props) => (props.$isActive ? "#EBF7F9" : "#F5F8FA")};
  }

  img {
    width: 20px;
    height: 20px;
  }

  span {
    color: #3f4254;
    font-size: 14px;
    font-weight: 500;
  }
`;

const Divider = styled.div`
  height: 1px;
  background: #e4e6ef;
  margin: 4px 12px;
`;

const ContentContainer = styled.div`
  position: relative;
  z-index: 1;
`;

// Add interface for location state
interface LocationState {
  defaultClaimType?: string;
  defaultDisplayText?: string;
}

export default function SettlementPageWrapper() {
  // Type the location with our interface
  const location = useLocation();
  const locationState = location.state as LocationState;

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [claimType, setClaimType] = useState(
    locationState?.defaultClaimType || "INPATIENT"
  );
  const [displayText, setDisplayText] = useState(
    locationState?.defaultDisplayText || "Rawat Inap"
  );
  const [searchType, setSearchType] = useState("Nama Member");
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    // Use locationState instead of location.state directly
    if (locationState?.defaultClaimType) {
      setClaimType(locationState.defaultClaimType);
      setDisplayText(locationState.defaultDisplayText || "Rawat Inap");
    }
  }, [locationState]);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleOptionClick = (type: string, text: string) => {
    setClaimType(type);
    setDisplayText(text);
    setIsDropdownOpen(false);
    setCurrentPage(1);
    setSearchType("Nama Member");
    setSearchQuery("");
  };

  const handleSearchTypeChange = (newSearchType: string) => {
    setSearchType(newSearchType);
    setSearchQuery("");
    setCurrentPage(1);
  };

  return (
    <>
      <GlobalStyle />
      <PageContainer>
        {/* <HeaderContainer>
          <HeaderTitle onClick={toggleDropdown}>
            <h1>{displayText}</h1>
            <ChevronDown size={20} color="#181C32" />
          </HeaderTitle>

          <DropdownMenu $isOpen={isDropdownOpen}>
            <DropdownItem
              $isActive={claimType === 'INPATIENT'}
              onClick={() => handleOptionClick('INPATIENT', 'Rawat Inap')}
            >
              <img src="media/svg/general/hospital.svg" alt="Hospital" />
              <span>Rawat Inap</span>
            </DropdownItem>

            <Divider />

            <DropdownItem
              $isActive={claimType === 'OUTPATIENT'}
              onClick={() => handleOptionClick('OUTPATIENT', 'Rawat Jalan')}
            >
              <img src="media/svg/general/ambulance.svg" alt="Ambulance" />
              <span>Rawat Jalan</span>
            </DropdownItem>
          </DropdownMenu>
        </HeaderContainer> */}

        <ContentContainer>
          <SettlementPage
            claimType={claimType}
            searchType={searchType}
            searchQuery={searchQuery}
            onSearchTypeChange={handleSearchTypeChange}
            onSearchQueryChange={setSearchQuery}
            currentPage={currentPage}
            onPageChange={setCurrentPage}
          />
        </ContentContainer>
      </PageContainer>
    </>
  );
}
